<button
  *ngIf="!searchType"
  [type]="type"
  [attr.data-testid]="testId || null"
  class="quantum-button"
  [class.tall]="tall"
  [class.small]="small"
  [class.medium]="medium"
  [class.black]="black"
  [disabled]="disabled"
  [class.red]="redAlert"
>
  {{ title }}
</button>

<div class="container" *ngIf="searchType" style="visibility: hidden">
  <form>
    <input
      type="search"
      placeholder="{{ 'button.search.placeholder' | translate }}"
    />
    <button
      [attr.data-testid]="testId || null"
      [disabled]="disabled"
      type="submit"
    >
      {{ 'button.search.submit' | translate }}
    </button>
  </form>
</div>
